// @ts-check

import { Trigger } from './Trigger'

/**
 * @typedef {Object} ExitIntentTriggerOptions
 * @property {number} minimumTimeOnPage how many seconds the user needs to be
 *           in the page for the trigger to be fired.
 */

/**
 * The Exit Intent Trigger is fired whenever the user's mouse leaves the document.
 * For avoiding spam, it is only fired once per session.
 */
class ExitIntentTrigger extends Trigger {
  timeoutHandler

  /**
   * @param {ExitIntentTriggerOptions} options
   */
  constructor({ minimumTimeOnPage }) {
    super()

    let reachedMinimumTimeOnPage = false
    this.timeoutHandler = setTimeout(() => {
      reachedMinimumTimeOnPage = true
    }, minimumTimeOnPage * 1000)

    /**
     *
     * @param {MouseEvent} event
     */
    this._fireEvent = (event) => {
      if (!event.relatedTarget && reachedMinimumTimeOnPage) {
        document.removeEventListener('mouseout', this._fireEvent)
        this._dispatch()
      }
    }
    document.addEventListener('mouseout', this._fireEvent)
  }

  destroy() {
    clearTimeout(this.timeoutHandler)
    document.removeEventListener('mouseout', this._fireEvent)
    super.destroy()
  }
}

export { ExitIntentTrigger }
